import React from 'react';
import { useTranslation } from 'react-i18next';
import OpArticle, { ArticleSection } from '../components/optimus/OpArticle';

interface WebSecurityImplementationPageProps {
  darkMode: boolean;
}

const CODE_CSP = `# netlify.toml
Content-Security-Policy = """
  default-src 'self';
  script-src 'self' 'sha256-<generated-hash>';
  style-src 'self' https://fonts.googleapis.com;
  img-src 'self' data:;
  connect-src 'self' https://api.talkhaled.com;
  frame-ancestors 'none';
"""`;

const CODE_HEADERS = `# netlify.toml
Strict-Transport-Security = "max-age=31536000; includeSubDomains; preload"
X-Content-Type-Options   = "nosniff"
X-Frame-Options          = "DENY"
Referrer-Policy          = "strict-origin-when-cross-origin"`;

const WebSecurityImplementationPage: React.FC<WebSecurityImplementationPageProps> = ({
  darkMode,
}) => {
  const { t } = useTranslation();
  const b = 'op.blog.sec';

  const sections: ArticleSection[] = [
    { title: t(`${b}.s1t`), paragraphs: [t(`${b}.s1p1`)] },
    { title: t(`${b}.s2t`), paragraphs: [t(`${b}.s2p1`)] },
    {
      title: t(`${b}.s3t`),
      paragraphs: [t(`${b}.s3p1`)],
      code: { filename: 'netlify.toml', content: CODE_CSP },
    },
    {
      title: t(`${b}.s4t`),
      paragraphs: [t(`${b}.s4p1`)],
      code: { filename: 'netlify.toml', content: CODE_HEADERS },
    },
    { title: t(`${b}.s5t`), paragraphs: [t(`${b}.s5p1`)] },
    {
      title: t(`${b}.s6t`),
      paragraphs: [t(`${b}.s6p1`)],
      stats: [
        { value: '110/100', label: t(`${b}.st1`) },
        { value: 'A+', label: t(`${b}.st2`) },
        { value: '100/100', label: t(`${b}.st3`) },
        { value: '0', label: t(`${b}.st4`) },
      ],
    },
  ];

  const takeaways = [1, 2, 3, 4].map((n) => ({
    title: t(`${b}.k${n}t`),
    description: t(`${b}.k${n}d`),
  }));

  return (
    <OpArticle
      darkMode={darkMode}
      slug="web-security-implementation"
      category={t(`${b}.category`)}
      title={t('blogPosts.webSecurityImplementation.title')}
      description={t('blogPosts.webSecurityImplementation.description')}
      date="2025-06-09"
      readingTime={7}
      tags={['Security', 'CSP', 'HSTS', 'HTTPS', 'Mozilla Observatory']}
      seoKeywords="web security implementation, content security policy, security headers, mozilla observatory, HSTS, A+ security rating"
      sections={sections}
      takeaways={takeaways}
    />
  );
};

export default WebSecurityImplementationPage;
